export default __webpack_public_path__ + "static/media/ProdSupport-Icon.8d7d54b9.png";